export enum DisabledGameFormatsToSchedule {
  'automated' = 'automated',
}
